// extracted by mini-css-extract-plugin
export default {"preloader":"Loder_preloader__l3Syv"};